import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, CanActivate, Router, RouterStateSnapshot, UrlTree } from '@angular/router';
import { Observable } from 'rxjs';
import { DataService } from '../services/data.service';

@Injectable({
  providedIn: 'root'
})
export class TtuFormAuthGuard implements CanActivate {
  constructor(private dataSRV: DataService, private router: Router) {}
  canActivate(
    route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot): Observable<boolean | UrlTree> | Promise<boolean | UrlTree> | boolean | UrlTree {
      const clientID = this.dataSRV.clientID?.toUpperCase();

      if (clientID === 'PA_TTU' && this.dataSRV.user?.ExtInfo?.toLowerCase()=='staff') {
        return true;
      } else {
        // Redirect to a different page if access is denied
        this.router.navigate(['/home']); // Adjust the path as needed
        return false;
      }
  }
 
  
}
